const items = ["Soho Goa", "Goa’s best nightclub", "Baga · North Goa", "9 PM till late", "house · techno · disco", "after dark", "zero ordinary"];

export const Marquee = () => {
  const group = (
    <div className="marquee-group">
      {items.map((item, i) => (
        <span key={i} className={i % 3 === 1 ? "serif" : i % 3 === 0 ? "solid" : "outline"}>{item}</span>
      ))}
    </div>
  );
  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee-track">{group}{group}</div>
    </div>
  );
};
